<template>
  <div class="animated fadeIn row">
    <nav class="navbar navbar-light bg-light w-full" style="padding: .5rem 1rem;margin-top: -20px;">
      <a class="navbar-brand" href="#"><b>รูปภาพ</b></a>
      <ul class="nav nav-pills" role="tablist">
        <li class="nav-item">
          <uploadImage :updateImageWithLink="false" :updateImageWithData="true" :isCrop="false" @upload="onUploadGallery"
            isInput="true" />
        </li>
      </ul>
    </nav>
    <draggable class="row" v-model="galleries">
      <div v-for="item in galleries" :key="item.id" class="col-md-6 col-sm-9 col-lg-4" style="">
        <div class="card">
          <img class="card-img-top" :src="item.url" alt="Card image cap" width="30rem" height="250rem" />
          <div class="gallery"></div>
          <div class="card-body">
            <h5 class="card-title" v-if="item.name !== 'image'">{{ item.name }}</h5>
            <b-btn class="mt-3" variant="outline-primary" block @click="onDelete(item.id, item.url)">
              <i class="fas fa-trash-alt"></i> ลบ
            </b-btn>
          </div>
        </div>
      </div>
    </draggable>
  </div>
</template>
<script>
  import draggable from 'vuedraggable';
  import uploadImage from '@/components/uploadImage'
  import {
    throws
  } from 'assert';
  export default {
    components: {
      uploadImage,
      draggable
    },
    data() {
      return {
        galleries: [],
      }
    },
    mounted() {
      this.getDataGalleries()
    },
    methods: {
      async onUploadGallery(data) {
        const {
          image,
          name,
          order
        } = data
        const nameImage = image.split('/')
        try {
          const res = await this.$http.post(process.env.VUE_APP_API_URL + 'api/v1/galleries', {
            'name': nameImage[nameImage.length - 1],
            'url': image,
            'order': '0'
          }, {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('z_token')
            }
          })
          await this.getDataGalleries()
        } catch (error) {
          alert('upload unsuccessfully')
          return error
        }
      },
      async getDataGalleries() {
        try {
          const res = await this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/galleries', {
            headers: {
              Authorization: 'Bearer ' + localStorage.getItem('z_token')
            },
            params: {
              page: 1,
              per_page: 100
            }
          })
          this.galleries = res.data.json.data
        } catch (error) {
          return error
        }
      },
      async onDelete(id, name) {
        const confirmDelete = confirm("ลบรูปใช่ไหม")
        if (confirmDelete) {
          try {
            const res = await this.$http.delete(process.env.VUE_APP_API_URL + 'api/v1/galleries/' + id, {
              headers: {
                Authorization: 'Bearer ' + localStorage.getItem('z_token')
              }
            })
            await this.getDataGalleries()
          } catch (error) {
            return error
          }
        }
      }
    }
  }

</script>

<style scoped>
  .gallery {
    background-repeat: 'no-repeat';
    background-size: 'contain';
    width: '40rem';
    height: '20px';
  }

</style>
